/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ since: NonNullable<unknown> }} Disconnected_SinceInputs */



/**
* | output |
* | --- |
* | "Disconnected since {since}" |
*
* @param {Disconnected_SinceInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const disconnected_since = /** @type {((inputs: Disconnected_SinceInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Disconnected_SinceInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`Disconnected since ${i?.since}`)
	return /** @type {LocalizedString} */ (`Déconnecté depuis ${i?.since}`)
});